import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { PaqueteSeguros } from '../../_models/paquete-seguros';
import { PaqueteSegurosService } from '../../_services/paquete-seguros.service';
import {Alerta} from '../../_models/alerta';

@Component( {
  selector: 'app-paquete-seguros-listado',
  templateUrl: 'paquete-seguros-listado.component.html'
} )

export class PaqueteSegurosListadoComponent implements OnInit {

  paqSeguros: PaqueteSeguros[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDetalle = false;
  pagSeguroSeleccionada: PaqueteSeguros;

  constructor( private pagSeguroServicio: PaqueteSegurosService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/paquete-seguros' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_NOMBRE' ), sort: true },
      { field: 'rangoMonto', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_RANGOMONTO' ), sort: true },
      { field: 'indicadorTradicional', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_SOLITRADI' ), sort: true },
      { field: 'indicadorDigital', header: this.navServicio.buscarMensaje( 'PAQUETESEGUROS.LBL_CREDIT' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },

      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'paquete-seguros.component' );

    this.pagSeguroServicio.listado().subscribe( paqSeguro => {
      paqSeguro.map( ( s: PaqueteSeguros ) => {
        s.rangoMonto = s.montoMinimo + ' ' + s.montoMaximo;
        this.paqSeguros.push( s );
      } );
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }
  get segPaqSeguros() {
   this.paqSeguros.sort(function (a, b) {
      if (a.montoMinimo > b.montoMinimo) {
        return 1;
      }
      if (a.montoMinimo < b.montoMinimo) {
        return -1;
      }
      return 0;
    });
    return this.paqSeguros;
  }

  crear() {
    this.router.navigate( [ 'apl/paquete-seguros/agregar' ] );
  }

  ver( palClave: PaqueteSeguros ) {
    this.router.navigate( [ 'apl/paquete-seguros/detalle/' + palClave.idPaqueteSeguro ] );
  }

  editar( palClave: PaqueteSeguros ) {
    this.router.navigate( [ 'apl/paquete-seguros/actualizar/' + palClave.idPaqueteSeguro ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'palabra-clave.component', this.busqueda );
  }

  cerrar() {
    this.mosDetalle = false;
  }


}
